import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { onMounted, ref } from 'vue';

export function useNativeAppVersion() {
	const appVersion = ref<string | undefined>();

	onMounted(async () => {
		if (!Capacitor.isNativePlatform()) {
			return;
		}

		try {
			const info = await App.getInfo();
			appVersion.value = info.version;
		} catch {
			// Ignore version lookup failures on unsupported platforms.
		}
	});

	return { appVersion };
}
